import styled, { css } from "styled-components";

import { ToastItemStyled } from "app/components/React/Toast/styles";

export const StyledLoadingToast = styled(ToastItemStyled)<{ hideCloseIcon: boolean }>`
    align-items: center;
    ${({ hideCloseIcon }) =>
        hideCloseIcon &&
        css`
            & + button {
                display: none;
            }
        `}
`;

export const StyledToastContent = styled.div<{ withContentPadding?: boolean }>`
    padding: ${({ withContentPadding }) => (withContentPadding ? "0 40px 0 0" : "0")};
`;
